import { ConfirmationDialog } from "@/components/ui/confirmation-dialog";

export function UnsavedGuard({ onStay, onDiscard }: { onStay: () => void; onDiscard: () => void }) {
	return (
		<ConfirmationDialog
			tone="destructive"
			title="Mudanças não salvas"
			description="Sair descartará as alterações."
			cancelLabel="Ficar"
			confirmLabel="Descartar"
			pendingLabel="Descartando"
			isPending={false}
			onConfirm={onDiscard}
			open
			onOpenChange={(open) => !open && onStay()}
			dialogSlot="unsaved-guard"
			cancelSlot="guard-stay"
			confirmSlot="guard-discard"
		/>
	);
}
